module.exports = __webpack_public_path__ + "img/img1.a14e68d3.jpg";